import cn from 'classnames';

import {
  dangerMenuItemStyles,
  linkMenuItemStyles,
  menuItemStyles,
  primaryMenuItemStyles,
  secondaryMenuItemStyles,
} from './styles';
import { MenuItemAppearanceType } from './types';

// on updating classes, crosscheck if anything needs to be updated in styles.ts
const MENU_ITEM_CLASSES = {
  danger: {
    endIconToken: 'icon-error',
    label: 'text-text-error',
    overlay: 'bg-bg-error-light',
    root: dangerMenuItemStyles,
    startIconToken: 'icon-error',
  },
  link: {
    endIconToken: 'icon-accent',
    label: 'text-text-accent',
    overlay: 'bg-bg-accent-light',
    root: linkMenuItemStyles,
    startIconToken: 'icon-accent',
  },
  primary: {
    endIconToken: 'icon-primary',
    label: 'text-text-primary',
    overlay: 'bg-bg-hover',
    root: primaryMenuItemStyles,
    startIconToken: 'icon-primary',
  },
  secondary: {
    endIconToken: 'icon-secondary',
    label: 'text-text-secondary',
    overlay: 'bg-bg-tertiary',
    root: secondaryMenuItemStyles,
    startIconToken: 'icon-secondary',
  },
};

export const getMenuItemClasses = (appearance: MenuItemAppearanceType) => {
  const config = MENU_ITEM_CLASSES[appearance];

  return {
    endIcon: {
      fillColorToken: config.endIconToken,
      icon: 'MenuItem-endIcon w-20 h-20',
      root: 'MenuItem-endIcon-root',
    },
    label: cn('MenuItem-label flex-1 truncate shrink', config.label),
    overlay: config.overlay,
    root: cn(
      'bg-bg-primary h-40 xs:h-50 py-0 gap-x-12 rounded-8 flex flex-row',
      config.root,
      menuItemStyles,
    ),
    startIcon: {
      fillColorToken: config.startIconToken,
      icon: 'MenuItem-startIcon w-20 h-20',
      root: 'MenuItem-startIcon-root',
    },
  };
};

interface Params {
  hasEndIcon: boolean;
  hasStartIcon: boolean;
}

export const getMenuItemPadding = ({ hasEndIcon, hasStartIcon }: Params) => {
  return cn('px-10', { 'ps-8': hasStartIcon }, { 'pe-8': hasEndIcon });
};
